import Dropzone, { FileRejection } from "react-dropzone";

import { Icon } from "components/icon/Icon";
import { UPLOAD_FILES_LIMIT } from "./fileInputConsts";

import "./FileInput.scss";

type FileInputProps = {
  onFilesAdded: (accepted: File[], rejected: FileRejection[]) => void;
  onDuplicatesDetected?: (duplicates: File[]) => void;
  fileSizeLimit?: number;
  filesNumberLimit?: number;
  disabled?: boolean;
  existingFiles?: File[];
};

export function FileInput({
  disabled = false,
  onFilesAdded,
  onDuplicatesDetected,
  filesNumberLimit = UPLOAD_FILES_LIMIT,
  fileSizeLimit,
  existingFiles = []
}: FileInputProps) {
  const isDuplicate = (file: File) =>
    existingFiles.some(
      (f) =>
        f.name === file.name &&
        f.size === file.size &&
        f.lastModified === file.lastModified
    );

  const handleDrop = (accepted: File[], rejected: FileRejection[]) => {
    const duplicates = accepted.filter(isDuplicate);
    const newFiles = accepted.filter((file) => !isDuplicate(file));

    onFilesAdded(newFiles, rejected);

    if (duplicates.length > 0 && onDuplicatesDetected) {
      onDuplicatesDetected(duplicates);
    }
  };

  return (
    <Dropzone
      disabled={disabled}
      maxSize={fileSizeLimit}
      maxFiles={filesNumberLimit}
      onDrop={handleDrop}
    >
      {({ getRootProps, getInputProps }) => (
        <div className={"file-upload-input-drop-zone"} {...getRootProps()}>
          <div className="file-upload-input-drop-zone-wrapper">
            <input {...getInputProps()} data-testid={"file-upload-input"} />
            <Icon name="cloud-upload" className="mr-4" />
            <span>
              Dra och släpp filer här eller <a>välj filer</a>
            </span>
          </div>
          {filesNumberLimit === UPLOAD_FILES_LIMIT && (
            <span className="d-block mt-3 text-center">
              Max femton filer per uppladdning
            </span>
          )}
        </div>
      )}
    </Dropzone>
  );
}
